import { render, staticRenderFns } from "./mySales.vue?vue&type=template&id=ed1cd6fe&scoped=true&"
import script from "./mySales.vue?vue&type=script&lang=js&"
export * from "./mySales.vue?vue&type=script&lang=js&"
import style0 from "./mySales.vue?vue&type=style&index=0&id=ed1cd6fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1cd6fe",
  null
  
)

export default component.exports